import { memo, useCallback } from 'react';
import { IconTextStyleStrike } from '../../../icons';
import { useTiptap } from '../Tiptap';
import { type Editor, useEditorState } from '@tiptap/react';
import TiptapToolbarButton from './tiptap-toolbar-button';

const TiptapStrike = memo(() => {
  const { editor } = useTiptap();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isStrike: editor.isActive('strike'),
    }),
  });

  const onClick = useCallback(
    () => editor.chain().focus().toggleStrike().run(),
    [editor],
  );

  return (
    <TiptapToolbarButton
      aria-label="barrer"
      tooltip="Barrer"
      icon={IconTextStyleStrike}
      isActive={editorState.isStrike}
      onClick={onClick}
    />
  );
});

TiptapStrike.displayName = 'Tiptap.Toolbar.Strike';

export default TiptapStrike;
